import {Helmet} from "react-helmet";
import classes from "../../../css/styles.module.scss";
import education_png from "./education.png";

const education = () => {
  return (
    <div>
      <Helmet><title>Backend Helpers Limited | Products | DevOps and Full-Stack Academy</title></Helmet>

      <main className={classes['main-content']}>
        <section id="" className={classes['project-content']}>

          <h1>DevOps Academy: Cloud DevOps Masterclass (Python, Terraform, AWS)</h1>

          <hr className={classes['bh-divider']}/>
          <h2> Program Duration: 3 Months (Intensive / Part-Time Options Available)</h2>
          <ul>

            <li>Are you a developer feeling the pressure to bridge the gap
              between code and deployment? </li>
            <li>
              Do you have programming fundamentals but find cloud infrastructure and continuous delivery a mystery?
            </li>

          </ul>
          <p>

            Join our  Cloud DevOps Masterclass is your fast-track to becoming a highly sought-after Cloud DevOps Engineer.
          </p>

         <h3>Who Is This Course For?</h3>

         <ul>
           <li>
             Developers: Ready to master the full software development lifecycle, from code to cloud.
           </li>

           <li>
             System Administrators / IT Professionals: Looking to modernize your skills with cloud and automation.
           </li>

          <li>
            Junior Software Engineers: Aiming to become a versatile "T-shaped" professional and accelerate your career.
          </li>

           <li>
             Anyone with basic programming logic experience who wants to transition into high-demand DevOps roles.
           </li>

         </ul>

          <h3>What You Will Master in 3 Months</h3>

          <p>

            <strong>Module 1:</strong> Cloud & DevOps Fundamentals with AWS Core Services (Month 1)
            <ul>
              <li>Introduction to DevOps: Principles, culture, and methodologies (CI/CD, SRE, Agile).</li>
              <li>AWS Fundamentals: Navigating the AWS console, IAM, VPC, EC2, S3, RDS, CloudWatch. </li>

              <li>Linux & Shell Scripting for DevOps: Essential commands, scripting for automation.</li>

              <li>Git & Version Control: Advanced workflows for collaborative development. </li>

              <li>Python for DevOps Basics: Scripting for system automation, interacting with APIs (Boto3 introduction).</li>

              <li>First Project: Deploying a simple web application to AWS EC2 using manual steps and basic Python scripts.</li>
            </ul>
          </p>
          <p>
            <strong>Module 2:</strong>  Infrastructure as Code & Automation with Terraform & Advanced AWS (Month 2)
            <ul>
            <li>
            Introduction to Infrastructure as Code (IaC): Why IaC, idempotency, state management.
            </li>
            <li>
            Terraform Deep Dive: HCL syntax, providers, resources, data sources, modules, workspaces.
            </li>

            <li>
            Automating AWS with Terraform: Deploying complex AWS architectures (VPCs, EC2, Load Balancers, Auto Scaling Groups, RDS) entirely via code.
            </li>

            <li>
            Advanced Python for AWS: Using Boto3 for dynamic resource management, Lambda functions for event-driven automation.
            </li>

            <li>
            Containerization with Docker: Building, managing, and orchestrating containers.
            </li>
            <li>
            Intermediate Project: Building a scalable, fault-tolerant application infrastructure on AWS using Terraform and Docker.
            </li>
            </ul>
          </p>
          <p>
            <strong>Module 3: CI/CD,</strong> Container Orchestration & Monitoring on AWS (Month 3)
            <ul>
              <li>
            Continuous Integration/Continuous Delivery (CI/CD): Principles and pipeline implementation.
              </li>
              <li>
            AWS CI/CD Services: AWS CodePipeline, CodeBuild, CodeDeploy.
              </li>
              <li>
            Container Orchestration with Amazon ECS/EKS: Deploying and managing containerized applications at scale.
              </li>
              <li>
            Advanced Python for CI/CD: Writing custom build/deploy scripts, integrating with CI/CD tools.
              </li>
              <li>
            Monitoring & Logging: Implementing CloudWatch, ELK/Grafana for observability.
              </li>
              <li>
            DevOps Security Best Practices: IAM roles, security groups, WAF, Secret Management (AWS Secrets Manager).
              </li>
              <li>
              Final Capstone Project: Design, implement, and automate a complete cloud-native application on AWS, incorporating all learned DevOps practices, CI/CD pipelines, and robust monitoring.
              </li>
            </ul>
          </p>

          <h3>Why Choose Backend Helpers Devops Academy?</h3>

          <p>

          <ul>
            <li>
            100% Hands-On: Learn by doing, with extensive labs and real-world projects.
            </li>
            <li>
            Industry-Expert Instructors: Taught by experienced Cloud DevOps Engineers actively working in the field.
            </li>
            <li>
            Career-Focused Curriculum: Aligned with current industry demands and leading to immediate job readiness.
            </li>
            <li>
            Dedicated Career Support: Resume workshops, interview preparation, and job placement assistance.
            </li>
            <li>
            Build a Powerful Portfolio: Graduate with demonstrable projects showcasing your expertise.
            </li>
            <li>
            Small Class Sizes: Personalized attention and mentorship.
            </li>
          </ul>
          </p>

          <img src={education_png}  alt="Devops Academy" className={classes['img-tech']}/>

        </section>
        </main>

    </div>
  );
};
export default education;